/* eslint-disable react/button-has-type,jsx-a11y/control-has-associated-label */
import React from 'react';

const getIconClasses = () => {
  const { cssRules } = Object.values(document.styleSheets).find((sheet) =>
    Object.values(sheet.cssRules).find((rule) => (rule.selectorText || '').match(/^.icon/))
  ) || { cssRules: {} };

  const classes = Object.values(cssRules).map((i) => i.selectorText);
  const filtered = classes.filter((c) => typeof c === 'string' && c.startsWith('.icon'));
  return filtered.map((c) => c.split('::')[0]);
};

const renderIcons = () => {
  const iconClasses = getIconClasses();
  const table = iconClasses.map((c) => (
    <tr key={c}>
      <td>
        <div className={`${c.substring(1)} p-3 text-f3`} />
      </td>
      <td>{c}</td>
    </tr>
  ));

  return <table>{table}</table>;
};

const Icons = () => (
  <>
    <h3 className="mt-4 p-3">This path is development only.</h3>
    <h1 className="px-3">{`${getIconClasses().length} icons found:`}</h1>
    {renderIcons()}
  </>
);

export default Icons;
